import { Component } from '@angular/core';
import { OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { UserService } from '../../services/user.service';
import { AlertsService } from '../../services/alerts.service';
import { GlobalRecordService } from '../../services/global-record.service';
import { SearchService } from '../../search/services/search.service';
import { MapService } from '../../map/services/map.service';

/**
 * Component providing a text view in list form of geographic search results.
 * This view supplements the mapped geographic results provided by MapViewComponent.
 */
@Component({
	selector: 'map-results-view',
	templateUrl: './map-results-view.component.html',
	styleUrl: './map-results-view.component.css'
})
export class MapResultsViewComponent implements OnInit, OnDestroy {

	private mapEventSubscription!: Subscription;
	private userEventSubscription!: Subscription;

	LOCALIZATION: any;

	filmstripRecords: any[] = [];
	filmstripRecordsView: any[] = [];

	geoFilmstrip: boolean = false;
	trackExtent: boolean = true;

	constructor(
		private userService: UserService,
		private alertsService: AlertsService,
		public globalRecordService: GlobalRecordService,
		private mapService: MapService,
		private searchService: SearchService
	) {
		this.LOCALIZATION = this.userService.LOCALIZATION;
	}

	ngOnInit(): void {
		this.userEventSubscription = this.userService.broadcastEvent.subscribe((event: string) => {
			if ('localizationLoaded' === event) {
				this.LOCALIZATION = this.userService.LOCALIZATION;
			}
		});
		
		this.mapEventSubscription = this.mapService.mapServiceEvent.subscribe((event: any) => {
			if ('filmstripResultUpdated' === event.eventType) {
				this.listenToFilmstripRecordsUpdatedEvent(event.data);
			}
		});
	}

	ngOnDestroy() {
		if (this.userEventSubscription) {
			this.userEventSubscription.unsubscribe();
		}
		
		if (this.mapEventSubscription) {
			this.mapEventSubscription.unsubscribe();
		}
	}

	private listenToFilmstripRecordsUpdatedEvent(data: any) {
		this.filmstripRecords = data.filmstripRecords;
		this.filmstripRecordsView = this.geoFilmstrip ? this.filmstripRecords.filter((record: any) => { return record.geo }) : this.filmstripRecords;
	}

	onZoomToFilmstrip(record: any): void {
		this.mapService.broadcastResult_ZoomToEvent({ record: record });
	}

	onUpdateMapRecordPreview(record: any): void {
		this.mapService.broadcastResult_UpdatePreviewEvent({ record: record });
	}

	onUpdateMapRecordActiveLocation(record: any, trigger: boolean): void {
		this.mapService.broadcastResult_UpdateActiveLocationEvent({ record: record, trigger: trigger });
	}

	toggleRecordId(id: number): void {
		let currentValue = this.globalRecordService.getRecord(id);
		this.globalRecordService.setRecord(id, !currentValue, true);
	}

	toggleTrackExtent(): void {
		this.mapService.broadcastTrackExtentEvent({ trackExtent: this.trackExtent });
	}

	// Not currently used
	toggleGeoFilmstrip(enabled: boolean) {
		this.geoFilmstrip = enabled;
		this.filmstripRecordsView = this.geoFilmstrip ? this.filmstripRecords.filter((record: any) => { return record.geo }) : this.filmstripRecords;
	}
}
